import React, { useState } from 'react';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';

import css from './ListingPage.module.css';

const SectionFAQ = ({ faq, showHeading = true }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!Array.isArray(faq) || faq.length === 0) return null;

  return (
    <section className={css.sectionFaq}>
      {showHeading ? (
        <div className={css.faqHeader}>
          <h3 className={css.faqTitle}>FAQ</h3>
          <span className={css.faqCount}>{faq.length}</span>
        </div>
      ) : null}

      <div className={css.faqList}>
        {faq.map((item, i) => {
          const isOpen = openIndex === i;
          const answerId = `listing-faq-answer-${i}`;

          return (
            <article key={`${item.q}-${i}`} className={classNames(css.faqItem, { [css.faqItemOpen]: isOpen })}>
              <button
                type="button"
                className={css.faqQuestion}
                onClick={() => setOpenIndex(isOpen ? null : i)}
                aria-expanded={isOpen}
                aria-controls={answerId}
              >
                <span className={css.faqQuestionText}>{item.q}</span>
                <ChevronDown className={css.faqQuestionIcon} aria-hidden="true" />
              </button>

              {isOpen ? (
                <div id={answerId} className={css.faqAnswer}>
                  <p className={css.faqAnswerText}>{item.a}</p>
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default SectionFAQ;
